import React from 'react';

function formatTime(ts) {
    if (!ts) return '';
    const d = new Date(ts);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

const ConversationHistoryPanel = ({
                                      items = [],
                                      onAssistantMessageClick,
                                      onToggleHistory
                                  }) => {
    if (!Array.isArray(items) || items.length === 0) {
        return (
            <div className="rounded-[8px] border border-[#E8E4FF]/80 bg-white backdrop-blur-sm overflow-hidden shadow-[0_0_8px_#00000040]">
                <div className="flex justify-between sticky top-0 z-10 px-2 md:px-3 py-4 bg-[#9C95DC] text-white font-bold">
                    Conversation History
                    <button className="w-[20px] h-[20px]" onClick={onToggleHistory}>x</button>
                </div>

                <div className=" max-h-[65vh] lg:max-h-[60vh] overflow-y-auto p-2 md:p-3 pr-3">
                    No conversation yet. Start speaking to build your history.
                </div>
            </div>
        );
    }

    return (
        <div className="rounded-[8px] border border-[#E8E4FF]/80 bg-white backdrop-blur-sm overflow-hidden shadow-[0_0_8px_#00000040]">
            <div className="flex justify-between sticky top-0 z-10 px-2 md:px-3 py-4 bg-[#9C95DC] text-white font-bold">
                Conversation History
                <button className="w-[20px] h-[20px]" onClick={onToggleHistory}>x</button>
            </div>

            <div className="max-h-[60vh] overflow-y-auto p-2 md:p-3 pr-3">
                {items.map((item) => {
                    const isUser = item.role === 'user';
                    const hasProducts = Array.isArray(item.products) && item.products.length > 0;
                    const hasQuery = typeof item.query === 'string' && item.query.trim();
                    const clickable = !isUser && (hasProducts || hasQuery);

                    return (
                        <div key={item.id} className={`w-full my-4 flex ${isUser ? 'justify-end' : 'justify-start'}`}>
                            <button
                                className={`max-w-[88%] text-left rounded-[15px] px-3.5 py-2.5 border transition ${
                                    isUser
                                        ? 'bg-[#9C95DC] text-white'
                                        : 'bg-[#E6E3FF] text-[#838383]'
                                }`}
                                onClick={() => clickable && onAssistantMessageClick?.(item)}
                                disabled={!clickable}
                            >
                                <div className="whitespace-pre-wrap break-words">
                                    {item.text}
                                </div>

                                <div className="mt-1 text-[11px] flex justify-between italic">
                                    <span>{isUser ? 'You' : 'Assistant'}</span>
                                    <span>{formatTime(item.timestamp)}</span>
                                </div>
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ConversationHistoryPanel;